import { render, staticRenderFns } from "./textNavCom.vue?vue&type=template&id=806a0f54&scoped=true"
import script from "./textNavCom.vue?vue&type=script&lang=js"
export * from "./textNavCom.vue?vue&type=script&lang=js"
import style0 from "./textNavCom.vue?vue&type=style&index=0&id=806a0f54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806a0f54",
  null
  
)

export default component.exports